/**
 * Is the person actually at the keyboard? The API hands leads only to agents
 * who are "at work", which it reads from the last request each session made.
 * The app polls in the background (notifications, the WhatsApp widget), so a
 * tab left open overnight looked like someone working. Every request now
 * carries `X-User-Active`, 1 when the tab is visible and the person touched
 * it recently, else 0; the API refreshes presence only on 1.
 */

/** How long after the last click / key / scroll we still count as active. */
export const ACTIVE_WINDOW_MS = 10 * 60 * 1000;

let lastInteractionAt = typeof performance !== 'undefined' ? Date.now() : 0;
let installed = false;

const mark = (): void => {
  lastInteractionAt = Date.now();
};

export const installUserActivityTracking = (): void => {
  if (installed || typeof window === 'undefined') return;
  installed = true;
  for (const ev of ['pointerdown', 'keydown', 'wheel', 'touchstart'] as const) {
    window.addEventListener(ev, mark, { passive: true, capture: true });
  }
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') mark();
  });
};

export const isUserActive = (now = Date.now()): boolean => {
  if (typeof document === 'undefined') return true;
  if (document.visibilityState === 'hidden') return false;
  return now - lastInteractionAt < ACTIVE_WINDOW_MS;
};
